export default __webpack_public_path__ + "static/media/coming_soon.b50241b0.jpg";